import { Component, Input, ViewEncapsulation } from '@angular/core';
import { EnpsControl } from '@common/controls/enps-control/enps-control';
import { MatSelectionListChange } from '@angular/material/list';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { optionContainsTerm } from '../../utils/util';

@Component({
    selector: 'status',
    templateUrl: './status.html',
    styleUrls: ['./status.scss'],
    encapsulation: ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        'class': 'st-status'
    }
})
export class Status extends EnpsControl<string> {

    protected _value: string;
    @Input()
    public get value(): string {
        return this._value;
    }
    public set value(v: string) {
        this._value = v;
        this.internalValue = (v) ? [v] : [];
    }

    @Input() public itemList: Array<{ id: string, title: string }> = [];
    statusFilter = new FormControl('');
    filteredOptions: Observable<string[]>;

    internalValue: string[] = [];

    get displayValue(): string {
        return (this.value) ? this.getItemStatusLabel(this.value) : this.placeholder;
    }

    private _filter(value: string): string[] {
        return this.itemList.filter(option => optionContainsTerm(option.id, value) || optionContainsTerm(option.title, value)).map((item) => item.id);
    }

    public getItemStatusLabel(item: any) {
        return this.itemList.find((i) => i.id === item)?.title;
    }

    internalValueChanged(event: MatSelectionListChange) {
        this.isValueChanged = true;
        this.value = event.options[0].value;
    }

    valueChanged() {
        if (this.isValueChanged) {
            this.isValueChanged = false;
            this.changed.emit(this.value);
        }
        this.statusFilter.setValue('');
    }

    public onMenuOpened(): void {
        super.onMenuOpened();
        this.filteredOptions = this.statusFilter.valueChanges.pipe(
            startWith(''),
            takeUntil(this.destroyed$),
            map(value => this._filter(value || '')),
        );
    }
}
